// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.now-only-balloon {
  display: inline-block;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(90deg, #e63946, #ff6b6b);
  padding: 0.25rem 2rem;
  position: relative;
  font-size: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.now-text {
  font-size: 1.4rem; /* テキストのサイズを大きく設定 */
  font-weight: bold;
  font-family: serif;
  color: #fff;
  letter-spacing: 0.3rem; /* 文字間隔を調整 */
}

/* 三角形のバルーン矢印 */
.now-only-balloon::before {
  content: "";
  position: absolute;
  width: 1rem;
  height: 0.75rem;
  background: linear-gradient(90deg, #e63946, #ff6b6b);
  bottom: -0.65rem; /* 微調整して三角形が見えるように */
  left: 0;
  right: 0;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  margin: auto;
}

`, "",{"version":3,"sources":["webpack://./src/styles/SimpleBalloon.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,oDAAoD;EACpD,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,mBAAmB;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,sBAAsB,EAAE,YAAY;AACtC;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,oDAAoD;EACpD,gBAAgB,EAAE,oBAAoB;EACtC,OAAO;EACP,QAAQ;EACR,yCAAyC;EACzC,YAAY;AACd","sourcesContent":[".now-only-balloon {\n  display: inline-block;\n  font-weight: bold;\n  color: #fff;\n  background: linear-gradient(90deg, #e63946, #ff6b6b);\n  padding: 0.25rem 2rem;\n  position: relative;\n  font-size: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}\n\n.now-text {\n  font-size: 1.4rem; /* テキストのサイズを大きく設定 */\n  font-weight: bold;\n  font-family: serif;\n  color: #fff;\n  letter-spacing: 0.3rem; /* 文字間隔を調整 */\n}\n\n/* 三角形のバルーン矢印 */\n.now-only-balloon::before {\n  content: \"\";\n  position: absolute;\n  width: 1rem;\n  height: 0.75rem;\n  background: linear-gradient(90deg, #e63946, #ff6b6b);\n  bottom: -0.65rem; /* 微調整して三角形が見えるように */\n  left: 0;\n  right: 0;\n  clip-path: polygon(0 0, 100% 0, 50% 100%);\n  margin: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
